import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Environment } from '../../environments/model/environment.model';

@Injectable({
  providedIn: 'root',
})
export class BeraterEnvironmentService {
  private environment: Environment;

  constructor() {
    this.environment = environment;
  }

  getApiUrl(): string {
    return this.environment.apiUrl;
  }

  getBaseUrl(): string {
    return this.environment.baseUrl;
  }

  getMaintenanceRefreshIntervall(): number {
    return 5000;
  }

  getLoggingAPIOBaseURL(): string {
    return '';
  }

  get getKeycloakUrl(): string {
    return this.environment.keycloakUrl;
  }

  get getStaticContentUrl() {
    return this.environment.staticContentUrl;
  }

  get getImpersonationTarget(): string {
    return this.environment.impersonationTarget;
  }

  get getImpersonationTargetUrl(): string {
    return this.environment.impersonationTargetUrl;
  }

  get getImpersonationCollaborationUrl(): string {
    return this.environment.impersonationCollaborationUrl;
  }

  get getImpersonationLogWienService(): string {
    return this.environment.impersonationLogWienService;
  }

  get getImpersonationLogWienPartner(): string {
    return this.environment.impersonationLogWienPartner;
  }

  get isProduction(): boolean {
    return this.environment.production;
  }

  get isRegistrationEnabled(): boolean {
    return this.environment.isRegistrationEnabled;
  }

  get getTicketingServiceUrl(): string {
    return this.environment.ticketingServiceUrl;
  }

  staticContent(): string {
    return '';
  }

  getPortalCustomerType(): string {
    return '';
  }
}
